module.exports = __webpack_public_path__ + "static/media/climate_launchpad.fd4dcea1.png";